/**
 * YouTube video gallery data for the home-page section.
 *
 * To add a new video: paste the YouTube ID (the string after v= in the URL)
 * and fill in title, description and category.
 * YouTube thumbnails are auto-generated from the ID.
 *
 * NOTE: slots 3-6 below reuse the two known YouTube IDs as placeholders
 * so the grid is visually complete. REPLACE with your own event IDs
 * when new captations are ready.
 */

export const GALLERY_VIDEOS = [
  {
    id: "1O0BxM9AtHY",
    title: "Showreel drones3x — spectacles 2025",
    description:
      "Compilation de nos plus beaux spectacles de drones réalisés en France : mariages, lancements de marque, festivals.",
    category: "Showreel",
    size: "lg",
    duration: "PT3M12S",
    uploadDate: "2025-06-01",
  },
  {
    id: "Bo0rIKtGPeg",
    title: "Spectacle de drones pour mariage — captation complète",
    description:
      "Un mariage sublimé par un spectacle de drones lumineux signé drones3x. Prénoms, cœur et date dessinés dans le ciel.",
    category: "Mariage",
    size: "md",
    duration: "PT2M48S",
    uploadDate: "2025-07-15",
  },
  {
    id: "Bo0rIKtGPeg",
    title: "Demande en mariage aérienne — spectacle de drones",
    description:
      "« Veux-tu m'épouser ? » écrit à 120 m d'altitude. Un spectacle de drones intimiste pour un moment inoubliable.",
    category: "Mariage",
    size: "md",
    duration: "PT1M55S",
    uploadDate: "2025-05-12",
  },
  {
    id: "1O0BxM9AtHY",
    title: "Lancement de produit — spectacle de drones corporate",
    description:
      "200 drones mobilisés pour un lancement de marque — logo géant, animations 3D et aftermovie cinéma.",
    category: "Corporate",
    size: "md",
    duration: "PT2M35S",
    uploadDate: "2025-08-20",
  },
  {
    id: "1O0BxM9AtHY",
    title: "Spectacle de drones festival — 800 drones synchronisés",
    description:
      "Production monumentale sur un festival d'été : 800 drones, 12 minutes, 50 000 spectateurs.",
    category: "Festival",
    size: "md",
    duration: "PT3M05S",
    uploadDate: "2025-07-30",
  },
  {
    id: "Bo0rIKtGPeg",
    title: "Cérémonie sportive — show aérien d'ouverture",
    description:
      "Ouverture d'une grande cérémonie sportive avec un spectacle de drones d'ouverture et de clôture.",
    category: "Sport",
    size: "md",
    duration: "PT2M12S",
    uploadDate: "2025-09-10",
  },
];

export const getYouTubeThumbnail = (videoId, quality = "maxres") => {
  // maxres | sd | hq | mq | default
  return `https://i.ytimg.com/vi/${videoId}/${quality}default.jpg`;
};

export const getYouTubeEmbedUrl = (videoId, opts = {}) => {
  const params = new URLSearchParams({
    rel: "0",
    modestbranding: "1",
    autoplay: opts.autoplay ? "1" : "0",
    ...(opts.params || {}),
  });
  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
};
